import * as React from 'react';
import type { PiletApi } from '@piral/portal';

export const PiletApiProvider = React.createContext<PiletApi>(undefined);
